






export default {
  name: 'geotap-logo'

  props: ['heading']
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GeotapLogo.vue